import React from "react";
import ContactInfo from "../../components/Contact Us/ContactInfo";
import ContactSection from "../../components/Contact Us/ContactSection";
import LatestServiceOffer from "../../components/common/LatestServiceOffer";
import ContactMap from "../../components/Contact Us/ContactMap";
import PageHeader from "../../components/common/PageHeader";

const Contact = () => {
  return (
    <div>
      <PageHeader title="Contact Us" />
      <ContactInfo />
      <ContactSection />
      <ContactMap />
      <LatestServiceOffer />
    </div>
  );
};

export default Contact;
